// Audience Requirements' backend (DA-5056; BE feat/audience-requirements,
// package A): the program keeps its Read & Assess and Read Only groups
// (audienceGroups), checks them (409, naming who would be in both), enrols
// whoever matches them, serves the designer's grid (GET
// programs/{id}/audienceRequirements) and each learner's access to each lesson.
//
// FLIP AFTER BE feat/audience-requirements DEPLOYS: this becomes `true`, and
// the flip PR deletes every DUMMY path it switches off (the browser-kept
// groups, the example groups, withDummyCapabilities and the access computed
// here) and lifts `requirementsPilot` with it, as DA-5055 did for shared
// capabilities. With it on, the learner's lesson page hides the Roleplay and
// the Quiz of a lesson they only read, for every org.
//
// Until then it is false in every build. A development build started with
// REACT_APP_AUDIENCE_REQUIREMENTS_BACKEND=on takes the backend path, so a QA
// run on the dev's FE can test it against a local BE on that branch
// (tests/journeys/audience-requirements.spec.ts). A production build never
// reads the variable: the whole expression is false there.
export const audienceRequirementsBackend = (): boolean =>
  process.env.NODE_ENV === 'development' &&
  (process.env.REACT_APP_AUDIENCE_REQUIREMENTS_BACKEND ?? '').trim().toLowerCase() === 'on';
